<template>
    <div id="baike-wrapper" :class="isShowMore ? 'fold' : 'unfold'" class="baike-wrapper">
        <div
            v-for="(item, index) of parseBlockList"
            :id="'baike-block-' + index"
            :key="index"
            :class="(index > 2 && !isShowMore) ? 'fadein' : ''"
            class="baike-item"
        >
            <div v-if="!!item.title" class="title"><span class="i-sty">{{ index > 9 ? index : '0' + index }}</span><span>. {{ item.title_text }}</span></div>
            <!-- eslint-disable vue/no-v-html -->
            <!--bca-disable-->
            <div
                v-lazy-container="{ selector: 'img' }"
                class="baike-item-content"
                v-html="item.content"
            >
            </div>
        </div>
        <div v-if="!isShowMore">
            <BaseInfo
                v-if="platBaseInfo"
                :basic-info="platBaseInfo"
                :has-margin="false"
            />
            <ContactUs
                v-if="contactInfo"
                :contact-info="contactInfo"
                :has-margin="false"
            />
        </div>
        <div v-show="isShowMore" class="more-wrapper shadow">
            <div v-show="!isLoading" class="more-content" @click="showMore">
                <div class="label">展开更多</div>
                <img
                    v-lazy="'https://b.bdstatic.com/searchbox/image/cmsuploader/20211020/1634727055575656.png'"
                    class="arraw-down"
                    large="a"
                >
            </div>
            <div v-show="isLoading" class="more-content">
                <div class="label">加载中...</div>
            </div>
        </div>
        <div v-show="!isShowMore" id="foldBaikeBtn" class="more-wrapper unfold">
            <div v-show="!isLoading" class="more-content" @click="foldBaike">
                <div class="label">收起</div>
                <div class="arraw-up"></div>
                <img
                    v-lazy="'https://b.bdstatic.com/searchbox/image/cmsuploader/20211020/1634727055575656.png'"
                    class="arraw-up"
                    large="a"
                >
            </div>
        </div>
    </div>
</template>

<script>
    // import BaseInfo from './app-detail-base-info';
    // import ContactUs from './app-detail-contact-us';
    import { on } from '@/utils/dom';
    import { throttle } from 'throttle-debounce';

    export default {
        components: {
            BaseInfo: () => import(/* webpackChunkName: 'zone-async' */ "./app-detail-base-info"),
            ContactUs: () => import(/* webpackChunkName: 'zone-async' */ "./app-detail-contact-us")
        },
        props: {
            blockList: {
                type: Array,
                default: () => ([])
            },
            isShowMore: {
                type: Boolean,
                default: true
            },
            isLoading: {
                type: Boolean,
                default: true
            },
            contactInfo: {
                type: Object,
                default: () => ({})
            },
            platBaseInfo: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                currentIndex: 0,
                parseBlockList: []
            }
        },
        watch: {
            blockList(val) {
                this.parseBlockList = this.parsedHyperText(val);
                this.$nextTick(() => {
                    this.initObserver();
                    this.refreshImg();
                });
            }
        },
        mounted() {
            this.parseBlockList = this.parsedHyperText(this.blockList);
            this.$nextTick(() => {
                this.initObserver();
                this.refreshImg();
            });
            const self = this;
            on(window, 'scroll', throttle(200, this.handleScroll.bind(self)));
        },
        methods: {
            initObserver() {
                this.baikeWrapper = document.getElementsByClassName('baike-wrapper')[0];
                this.baikeBlocks = document.getElementsByClassName('baike-item');
                this.clientTop = document.body.clientHeight * 0.33;
                this.titleHeight = Math.floor(340 * (window.innerWidth / 1242));
            },
            handleScroll() {
                if (this.baikeWrapper) {
                    const { top, bottom } = this.baikeWrapper.getBoundingClientRect();
                    if (top < this.clientTop && bottom > 0) {
                        this.$emit('baikeWrapperChange', {
                            isIntersecting: true
                        });
                    } else {
                        this.$emit('baikeWrapperChange', {
                            isIntersecting: false
                        });
                    }
                }
                
                if (this.baikeBlocks && this.baikeBlocks.length) {
                    this.baikeBlocks.forEach((ele) => {
                        const { top } = ele.getBoundingClientRect();
                        if (top > this.titleHeight && top < (this.titleHeight + 200)) {
                            this.$emit('baikeBlockChange', {
                                id: ele.id
                            });
                        }
                    });
                }
            },
            showMore() {
                this.$emit('showMore');
            },
            foldBaike() {
                this.$emit('foldBaike', 'fixed');
            },
            refreshImg() {
                this.$nextTick(() => {
                    const imgList = document.querySelectorAll('#baike-wrapper img');
                    imgList.forEach((img) => {
                        img.setAttribute('preview', '998');
                    });
                    this.$previewRefresh();
                });
            },
            parsedHyperText(blockList) {
                blockList.forEach((item) => {
                    let content = item.content;
                    // content = content
                    //     && content.replace(/<img/g, `
                    //     <img
                    //         class="common-img"
                    //         style="border-radius: 2.9vw; max-height: 51.7vw; max-width: 91.78vw;
                    //             padding-top: 4.35vw; padding-bottom: 4.35vw;"
                    // `);
                    content = content
                        && content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, (match, capture) => {
                            return `
                            <img
                                class="common-img"
                                style="border-radius: 2.9vw; max-height: 51.7vw; max-width: 91.78vw;
                                    padding-top: 4.35vw; padding-bottom: 4.35vw;"
                                data-src=${capture}/>`
                        });
                    item.content = content;
                });
                return blockList;
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;
    .baike-wrapper {
        position: relative;
        width: 100%;
        min-height: px2rem(300);
        &.fold {
            overflow: hidden;
            max-height: px2rem(1200);
            padding-bottom: px2rem(20);
        }
        &.unfold {
            padding-bottom: px2rem(190);
        }
        .baike-item {
            position: relative;
            font-size: px2rem(48);
            color: #1F1F1F;
            text-align: justify;
            line-height: 75px;
            font-weight: 400;
            margin-bottom: px2rem(45);
            &.fadein {
                animation: opacity-gradient 0.4s 1;
                -webkit-animation: opacity-gradient 0.4s 1;
            }
            .title {
                color: #1F1F1F;
                text-align: justify;
                font-weight: 600;
                line-height: px2rem(75);
                span {
                    font-weight: 600;
                }
                .i-sty {
                    font-style: italic;
                }
            }
            &-content {
                font-size: px2rem(48) !important;
                line-height: px2rem(75) !important;
                width: 100%;
                overflow: hidden;
            }
            &-content * {
                font-size: px2rem(48) !important;
                line-height: px2rem(75) !important;
                font-weight: 400;
            }
            &-content h1,h2,h3,h4,h5,h6 {
                font-size: px2rem(48) !important;
                line-height: px2rem(75) !important;
            }
            &-content ::v-deep img {
                max-width: px2rem(1140) !important;
                max-height: px2rem(642) !important;
                border-radius: px2rem(27) !important;
            }
            &-content img {
                max-width: px2rem(1140) !important;
                max-height: px2rem(642) !important;
                border-radius: px2rem(27) !important;
            }
            img, image, .common-img{
                max-width: 91.78vw !important;
                max-height: 51.7vw !important;
                padding-top: 4.35vw !important;
                padding-bottom: 4.35vw !important;
                border-radius: 2.9vw !important;
            }
            .baike-wrapper-content ::v-deep .MsoNormal {
                font-size: px2rem(48) !important;
                line-height: px2rem(75) !important;
            }
            .baike-wrapper-content .MsoNormal {
                font-size: px2rem(48) !important;
                line-height: px2rem(75) !important;
            }
            .media {
                margin-bottom: px2rem(60);
                .image {
                    width: 100%;
                    height: px2rem(640);
                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: px2rem(27);
                    }
                }
            }
        }
        .more-wrapper {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: px2rem(300);
            &.unfold {
                padding-top: px2rem(65);
                height: px2rem(125);
            }
            &.shadow {
                background-image: linear-gradient(
                    rgba(255,255,255, 0.00) 0%,
                    rgba(255,255,255, 0.94) 32%,
                    #FFFFFF 100%);
            }
            .more-content {
                position: absolute;
                bottom: px2rem(0);
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: px2rem(345);
                width: px2rem(450);
                height: px2rem(111);
                border-radius: px2rem(27);
                border: px2rem(1) solid #3388FF;
                .label {
                    font-size: px2rem(48);
                    color: #3388FF;
                    text-align: right;
                    line-height: px2rem(48);
                    font-weight: 400;
                    margin-right: px2rem(18);
                }
                .arraw-down {
                    width: px2rem(54);
                    height: px2rem(54);
                }
                .arraw-up {
                    width: px2rem(54);
                    height: px2rem(54);
                    transform: rotate(180deg);
                }
            }
        }
    }
    @keyframes opacity-gradient {
        0% {
            opacity: 0;
        }
        100% {
             opacity: 1;
        }
    }
</style>